const SYNTHETIC_KEYS = ["_syntheticId", "_ctid", "_rowNumber"] as const;

const isPresent = (value: unknown): boolean =>
  value !== undefined && value !== null;

/**
 * Identity the API can address: the declared key column, then the first
 * synthetic the server attached. Undefined means there is nothing to PUT/DELETE.
 */
export const rowKey = (row: any, idField?: string): string | undefined => {
  if (row == null || typeof row !== "object") return undefined;
  if (idField && isPresent(row[idField])) return String(row[idField]);
  for (const synthetic of SYNTHETIC_KEYS) {
    if (isPresent(row[synthetic])) return String(row[synthetic]);
  }
  return undefined;
};

/** Stable, non-throwing row key for tables without a primary key. */
export const hashRow = (row: any): string => {
  const source = Object.entries(row)
    .filter(([key]) => !key.startsWith("_"))
    .map(([key, value]) => `${key}:${String(value)}`)
    .sort()
    .join("|");
  let hash = 5381;
  for (let i = 0; i < source.length; i++) {
    hash = ((hash << 5) + hash + source.charCodeAt(i)) | 0;
  }
  return `row_${(hash >>> 0).toString(36)}`;
};

/** Grid `getRowId`: a real identity when one exists, otherwise a stable hash. */
export const rowKeyOrHash = (row: any, idField?: string): string =>
  rowKey(row, idField) ?? hashRow(row);

/**
 * Update target for the record editor. The opened row is first because the
 * form strips `_syntheticId` / `_ctid` / `_rowNumber` from the submitted
 * payload. Callers that omit `idField` still resolve Postgres `id`.
 */
export const formUpdateId = (
  opened: any,
  submitted: any,
  idField?: string
): string | undefined => {
  const field = idField ?? "id";
  return rowKey(opened, field) ?? rowKey(submitted, field);
};
